export default {
  admin: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/layouts/admin.vue"),
  default: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/layouts/default.vue"),
  embed: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/layouts/embed.vue"),
  mypage: () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/layouts/mypage.vue"),
  "no-menu": () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/layouts/noMenu.vue"),
  "no-menu-container": () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/layouts/noMenuContainer.vue"),
  "no-menu-no-card": () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/layouts/noMenuNoCard.vue"),
  "no-menu-plan-edit": () => import("/home/runner/work/fincs-webfront/fincs-webfront/src/layouts/noMenuPlanEdit.vue")
}